import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { IconButton } from 'components/shared/IconButton/IconButton'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { CandidateCell } from 'components/shared/Table/common/Cells/CandidateCell/CandidateCell'
import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { JobProgressCell } from 'components/shared/Table/common/Cells/JobProgressCell/JobProgressCell'
import { LanguageCell } from 'components/shared/Table/common/Cells/LanguageCell/LanguageCell'
import { PhoneCell } from 'components/shared/Table/common/Cells/PhoneCell/PhoneCell'
import { Table } from 'components/shared/Table/Table'
import { CandidatesTable } from '../../../CandidatesTable/CandidatesTable'
import { useCandidatesTable } from 'components/pages/Jobs/JobDetails/hooks'
import { getColumns } from './model'
import { HIRE_STATUSES } from '../../../model'

import { MailIcon } from 'components/shared/Icon/model'

import styles from './InvitesTable.module.scss'
import jobStyles from '../../../JobDetails.module.scss'

const mapSortingPropToQueryParam = {
  email: 'email',
  invited: 'invited',
  name: 'name',
  status: 'status',
}

export const InvitesTable = ({
  projectId,
  search,
  filter,
  setFilter,
  tab,
  getActions,
  onSendTestsMessage,
  handleFavorite,
  hasInterviewModule,
  isAtsLocked,
  active,
}) => {
  const columns = getColumns()

  const status = React.useMemo(() => ['created', 'invited'], [])

  const {
    state: {
      table: {
        headers,
        model,
        rowSelection,
        isAllRowsSelected,
        isFetching,
        isSomeRowsSelected,
      },
      pagination: { currentPage, pageCount, perPage },
    },
    handlers: {
      table: { toggleAllRowsSelectedHandler },
      pagination: { handlePage, handlePageSize },
    },
  } = useCandidatesTable({
    columns,
    mapSortingPropToQueryParam,
    projectId,
    search,
    filter,
    tab,
    status,
  })

  return (
    <CandidatesTable
      {...{
        active,
        headers,
        isAllRowsSelected,
        isFetching,
        isSomeRowsSelected,
        currentPage,
        pageCount,
        perPage,
        toggleAllRowsSelectedHandler,
        handlePage,
        handlePageSize,
        filter,
        setFilter,
      }}
      placeholder={{
        title: t`No candidates on this stage`,
        text: t`There are currently no candidates to invite`,
      }}
    >
      {R.map(
        ({
          id,
          original,
          getIsSelected,
          getIsSomeSelected,
          getToggleSelectedHandler,
        }) => {
          const {
            email,
            language,
            name,
            phone,
            selection_stage,
            status,
            timestamps,
            hire_status,
            is_favourite,
            id: candidateId,
          } = original

          const label = timestamps?.invited ? undefined : t`not invited`

          const actions = getActions({ candidate: original })

          return (
            <Table.Row
              key={id}
              type="body"
              onChange={getToggleSelectedHandler()}
              isChecked={getIsSelected()}
              isIndeterminate={getIsSomeSelected()}
              isSelected={rowSelection[id]}
              isHighlighted={hire_status === HIRE_STATUSES.HIRED}
              hasCheckbox
              className={jobStyles.row}
              isDisabled={!active}
            >
              <CandidateCell
                email={email}
                name={name}
                className={active ? jobStyles.favoriteIcon : undefined}
                isFavorite={is_favourite}
                setFavorite={handleFavorite(candidateId)}
                active={active}
              />
              <PhoneCell phone={phone} />
              <LanguageCell language={language} />
              <DateCell date={timestamps?.invited} label={label} hasNowLabel />
              <JobProgressCell
                progress={selection_stage - 1}
                status={status}
                type="candidate"
                {...{ hasInterviewModule }}
              />
              <ActionsCell>
                <IconButton
                  className={styles.button}
                  icon={MailIcon}
                  size="medium"
                  variant="text"
                  isDisabled={!active}
                  onClick={() => onSendTestsMessage({ candidate: original })}
                  isLocked={isAtsLocked}
                />
                <ActionsDropdown
                  anchorClassName={styles.button}
                  size="medium"
                  isDisabled={!active}
                  {...{ actions }}
                />
              </ActionsCell>
            </Table.Row>
          )
        },
        model.rows,
      )}
    </CandidatesTable>
  )
}
